import { SignaturePad, SignaturePadRef } from "ui/atoms/signaturePad";
import { View } from "ui/atoms/view";
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import { Button, ButtonText } from "ui/gluestack/button";

export interface SignaturePadModalRef {
  show: () => void;
}

interface Props {
  title?: string;
  onClose?: (signature?: string | null) => void;
  onUse: (signature?: string | null) => void;
}
export const SignaturePadModal = forwardRef<SignaturePadModalRef, Props>(
  ({ title, onClose, onUse }, ref) => {
    const [show, setShow] = useState(false);
    const signatureRef = useRef<SignaturePadRef>(null);

    useImperativeHandle(ref, () => ({
      show: () => {
        setShow(true);
      },
    }));

    const handleUse = async () => {
      const signature = await signatureRef.current?.exportToPNG();
      onUse(signature);
      setShow(false);
    };
    return (
      <ReusableModal
        isVisible={show}
        onClose={() => {
          setShow(false);
          onClose?.();
        }}
        title={title || "Signature"}
      >
        <SignaturePad ref={signatureRef} />

        <View className="flex flex-row gap-2 mt-2">
          <Button
            onPress={() => signatureRef.current?.clear()}
            variant="outline"
            size="sm"
            className="flex-1"
          >
            <ButtonText>Clear</ButtonText>
          </Button>
          <Button
            onPress={handleUse}
            variant="solid"
            size="sm"
            className="flex-1"
          >
            <ButtonText>Use</ButtonText>
          </Button>
        </View>
      </ReusableModal>
    );
  },
);
